/*
 * il-funnel.js — THE single shared cold-funnel engine.
 *
 * ONE function per CTA, called identically by every funnel. Nothing per-funnel is
 * hardcoded here: all values come from window.IL_FUNNEL, injected by the theme
 * (sections/funnel-landing.liquid) from the product + its metafields. Bodies contain
 * only copy + canonical hooks. Loaded by the THEME (not body_html), so one update
 * reaches every funnel and it lives outside the body-rewrite pipeline.
 *
 * Replaces: il-lead-magnet.js (+ its -capture.js twin), il-funnel-buy.js,
 * the funnel-freeship-gate snippet, and the 3 sample paths
 * (data-action="sample" / data-pr-atc / data-ds-atc).
 *
 * window.IL_FUNNEL = {
 *   productId, productName, currency,
 *   buyVariantId, price,                 // buy (dollars)
 *   sampleVariantIds,                    // [] | [id] | [id,id] (single or combo)
 *   pdfUrl, reportName, funnelSlug,      // lead magnet
 *   subscribeListId, applyDiscount,      // capture list + optional checkout discount code
 *   ga4Id, adsAtc, adsChk, klaviyoCompany  // tracking ids (theme-provided; fallbacks below)
 * };
 *
 * Canonical body hooks (the ONLY funnel-specific markup):
 *   CTA1: #cta1-form #cta1-email #cta1-btn #cta1-err #cta1-success #cta1-download
 *   CTA2: <button data-il-sample>  (optional data-il-sample-ids override; else config)
 *   CTA3: #final-atc-btn  (optional #final-gate-email / #final-gate-err)  [data-il-buy-price]
 *   reviews: __IL_FUNNEL_REVIEWS__ (rendered server-side by the section)
 */
(function () {
  var C = window.IL_FUNNEL || {};
  var GA4 = C.ga4Id || 'G-XE6CZ5DL31',
      AW_ATC = C.adsAtc || 'AW-870900097/zGb0COu467wcEIHDo58D',
      AW_CHK = C.adsChk || 'AW-870900097/lAM0COi467wcEIHDo58D',
      KL_CO = C.klaviyoCompany || 'Rksq6z';
  var DISPOSABLE = ['mailinator','guerrillamail','yopmail','trashmail','sharklasers','tempmail','throwaway','fakeinbox','maildrop','dispostable','10minutemail','temp-mail','getairmail','armyspy','mailsac','spamgourmet','burnermail','discardmail','no-spam','grr.la','jetable','pookmail','trash-mail'];

  function validEmail(v) {
    if (!v || !/^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/.test(v)) return false;
    var d = v.split('@')[1].toLowerCase();
    for (var i = 0; i < DISPOSABLE.length; i++) if (d.indexOf(DISPOSABLE[i]) !== -1) return false;
    return true;
  }

  // ---- optional text-message capture ------------------------------------------
  // ONE implementation, used by both the lead-magnet form (#cta1-phone) and the buy
  // card (#final-gate-phone). Klaviyo requires E.164; identify() stores a number but
  // grants no consent, so the subscriptions endpoint is what makes it sendable.
  function toE164(v) {
    try {
      var raw = (v || '').replace(/[^0-9+]/g, '');
      if (raw.charAt(0) === '+' && raw.length >= 11) return raw;
      var dg = raw.replace(/\D/g, '');
      if (dg.length === 10) return '+1' + dg;
      if (dg.length === 11 && dg.charAt(0) === '1') return '+' + dg;
    } catch (e) {}
    return '';
  }
  function subscribePhone(email, phone) {
    if (!phone) return;
    try {
      var attrs = { phone_number: phone,
        subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } } };
      if (email) { attrs.email = email; attrs.subscriptions.email = { marketing: { consent: 'SUBSCRIBED' } }; }
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KL_CO, {
        method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({ data: { type: 'subscription', attributes: {
          custom_source: 'funnel ' + (C.funnelSlug || 'lead magnet'),
          profile: { data: { type: 'profile', attributes: attrs } } },
          relationships: { list: { data: { type: 'list', id: C.smsListId || 'SyG8y4' } } } } })
      }).catch(function () {});
    } catch (e) {}
  }

  // ---- attribution -----------------------------------------------------------
  // First-touch (for Klaviyo): captured on the landing page, survives navigation.
  var FT_KEY = 'il_first_touch';
  function firstTouch() {
    try {
      var stored = JSON.parse(localStorage.getItem(FT_KEY) || 'null');
      var q = new URLSearchParams(location.search);
      if (!stored || ((q.get('utm_source') || q.get('utm_campaign')) && !stored.utm_source)) {
        stored = {
          utm_source: q.get('utm_source') || '', utm_medium: q.get('utm_medium') || '',
          utm_campaign: q.get('utm_campaign') || '', utm_content: q.get('utm_content') || '',
          utm_term: q.get('utm_term') || '', utm_adset: q.get('utm_adset') || '',
          first_landing_page: location.pathname + location.search,
          referrer: document.referrer || '', lead_date: new Date().toISOString()
        };
        localStorage.setItem(FT_KEY, JSON.stringify(stored));
      }
      return stored || {};
    } catch (e) { return {}; }
  }
  function deriveSource(ft) {
    if (ft.utm_source) return ft.utm_source;
    var ref = (ft.referrer || document.referrer || '').toLowerCase();
    if (ref.indexOf('facebook') !== -1 || ref.indexOf('fb.') !== -1 || ref.indexOf('instagram') !== -1) return 'Facebook';
    if (ref.indexOf('google') !== -1) return 'Google';
    if (ref.indexOf('pinterest') !== -1) return 'Pinterest';
    return ref ? 'Referral' : 'Direct';
  }
  // Ad-click ids (for the Shopify cart/order): written by snippets/funnel-identity.liquid.
  function readAcq() { try { return JSON.parse(localStorage.getItem('ild_acq') || '{}'); } catch (e) { return {}; } }
  // GA4 client_id (for BigQuery/Klaviyo join): written by snippets/ild-click-id-capture.liquid.
  function readClickIds() { try { return JSON.parse(localStorage.getItem('ild_click_ids') || '{}'); } catch (e) { return {}; } }
  function cartAttributes() {
    var a = readAcq();
    return { _gclid: a.gclid || a.gbraid || a.wbraid || '', fbclid: a.fbclid || '',
      utm_source: a.utm_source || '', utm_campaign: a.utm_campaign || '', utm_term: a.utm_term || '',
      utm_medium: a.utm_medium || '', landing_page: a.landing_page || '', first_source: a.first_source || '',
      ild_acq_ts: a.ts ? String(a.ts) : '', funnel_free_ship_code: C.applyDiscount || '' };
  }

  // ---- tracking events -------------------------------------------------------
  function ga4Ads(kind, cur, value, items, step) {
    if (typeof gtag !== 'function') return;
    if (kind === 'add_to_cart') { gtag('event', 'add_to_cart', { send_to: GA4, currency: cur, value: value, items: items, funnel_step: step || '' }); gtag('event', 'conversion', { send_to: AW_ATC, currency: cur, value: value }); }
    else if (kind === 'begin_checkout') { gtag('event', 'begin_checkout', { send_to: GA4, currency: cur, value: value, items: items }); }
  }

  // ---- CTA1: lead magnet -----------------------------------------------------
  function initLeadMagnet() {
    var form = document.getElementById('cta1-form'); if (!form) return;
    var emailEl = document.getElementById('cta1-email'),
        phoneEl = document.getElementById('cta1-phone'),   // optional: text-message capture
        err = document.getElementById('cta1-err'), btn = document.getElementById('cta1-btn'),
        success = document.getElementById('cta1-success'), download = document.getElementById('cta1-download');
    var btnText = btn ? btn.textContent : '';
    // Friction events: separate "never saw the offer" from "saw it, ignored it"
    // from "started typing and abandoned". Without these you only learn THAT
    // people did not convert, never where they stopped.
    try {
      var started = false;
      if (emailEl) emailEl.addEventListener('input', function () {
        if (started) return; started = true;
        try { if (typeof gtag === 'function') gtag('event', 'form_start', { send_to: GA4, funnel: C.funnelSlug || '' }); } catch (e4) {}
      });
      if (window.IntersectionObserver) {
        var seen = false;
        var io = new IntersectionObserver(function (entries) {
          if (seen) return;
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              seen = true;
              try { if (typeof gtag === 'function') gtag('event', 'view_lead_form', { send_to: GA4, funnel: C.funnelSlug || '' }); } catch (e5) {}
              io.disconnect(); break;
            }
          }
        }, { threshold: 0.4 });
        io.observe(form);
      }
    } catch (e6) {}
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (emailEl.value || '').trim();
      if (!validEmail(email)) { if (err) err.style.display = 'block'; return; }
      if (err) err.style.display = 'none';
      // Optional phone. Never blocks the guide: a bad number is dropped, the email still goes.
      var phone = toE164(phoneEl ? phoneEl.value : '');
      if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
      var ft = firstTouch();
      var acq = readAcq(), clickIds = readClickIds();
      var interestVal = C.productInterest || C.productName || '';
      // Primary Goal stays sticky across visits (Universal Nurture Flow branching) —
      // persisted in the same first-touch record so a later download of a different
      // guide doesn't overwrite the original interest.
      if (!ft.primary_goal && interestVal) { ft.primary_goal = interestVal; try { localStorage.setItem(FT_KEY, JSON.stringify(ft)); } catch (e1) {} }
      var props = { funnel: C.funnelSlug, product_interest: interestVal, interest: interestVal,
        entry_asset: C.reportName || '', primary_goal: ft.primary_goal || interestVal, lead_magnet: C.reportName || '',
        source: deriveSource(ft), campaign: ft.utm_campaign || '', adset: ft.utm_adset || ft.utm_term || '', ad: ft.utm_content || '',
        utm_source: ft.utm_source || '', utm_medium: ft.utm_medium || '', utm_campaign: ft.utm_campaign || '',
        utm_content: ft.utm_content || '', utm_term: ft.utm_term || '',
        first_landing_page: ft.first_landing_page || (location.pathname + location.search),
        lead_date: ft.lead_date || new Date().toISOString(), purchase_status: 'lead',
        // Click ids: same store already trusted for Shopify order attribution
        // (readAcq/cartAttributes above) — the Klaviyo profile was the one
        // place these never reached. ga_client_id has no ild_acq equivalent,
        // so it comes from ild-click-id-capture.liquid's store instead.
        gclid: acq.gclid || '', gbraid: acq.gbraid || '', wbraid: acq.wbraid || '', fbclid: acq.fbclid || '',
        ga_client_id: clickIds.ga_client_id || '' };
      var fd = new FormData(); fd.append('form_type', 'customer'); fd.append('utf8', '✓'); fd.append('contact[email]', email);
      if (phone) fd.append('contact[phone]', phone);
      if (C.pdfTags) fd.append('contact[tags]', C.pdfTags);
      fetch('/contact', { method: 'POST', body: fd }).catch(function () {});
      subscribePhone(email, phone);
      try {
        var idp = {}; for (var k in props) idp[k] = props[k]; idp['$email'] = email;
        if (phone) idp['$phone_number'] = phone;
        var ev = { report_name: C.reportName, report_url: C.pdfUrl }; for (var k2 in props) ev[k2] = props[k2];
        if (window.klaviyo && window.klaviyo.identify) { window.klaviyo.identify(idp); window.klaviyo.track('Requested Lead Magnet', ev); }
        else if (window._learnq) { window._learnq.push(['identify', idp]); window._learnq.push(['track', 'Requested Lead Magnet', ev]); }
      } catch (e2) {}
      // 2026-07-28: neither GA4 nor Meta ever recorded a lead. Landing->lead
      // friction was invisible to both, and Meta had no Lead signal to optimise
      // toward -- which is what a lead-optimised cold campaign needs.
      try {
        if (typeof gtag === 'function') {
          gtag('event', 'generate_lead', { send_to: GA4, funnel: C.funnelSlug || '',
            lead_magnet: C.reportName || '', adset: props.adset || '', campaign: props.campaign || '' });
        }
        if (typeof fbq === 'function') {
          fbq('track', 'Lead', { content_name: C.reportName || '', content_category: C.funnelSlug || '' });
        }
      } catch (e3) {}
      window.__funnelLeadEmail = email;
      var fgs = document.querySelectorAll('#final-gate-email');
      for (var fi = 0; fi < fgs.length; fi++) fgs[fi].value = email;
      if (download && C.pdfUrl) download.href = C.pdfUrl;
      form.style.display = 'none'; if (success) success.style.display = 'block';
      if (btn) { btn.disabled = false; btn.textContent = btnText; }
    });
  }

  // AW checkout conversion moves to the drawer's real Check out click (GA4
  // begin_checkout is funnel-landing.js's job). Capture phase; gtag transport
  // is beacon-style so the form submission is not raced or gated.
  var lastCartSnapshot = null;
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('#CartDrawer-Checkout')) return;
    if (typeof gtag !== 'function') return;
    var cart = lastCartSnapshot || {};
    gtag('event', 'conversion', { send_to: AW_CHK, currency: cart.currency || C.currency || 'USD', value: parseFloat(((cart.total_price || 0) / 100).toFixed(2)) });
  }, true);

  // ---- CTA -> slide-out cart drawer -----------------------------------------
  // Funnel pages render on theme.liquid, which already includes <cart-drawer>.
  // Same refresh pattern as snippets/funnel-page-atc.liquid / cart.js: fetch the
  // re-rendered section and let renderContents swap it in (it re-opens itself).
  // /cart is only the fallback for a page without the drawer.
  function openDrawerOrCart() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') {
      // Bare-layout funnel: funnel-landing.js v19 lazy-boots the drawer.
      if (typeof window.__funnelOpenDrawer === 'function') {
        window.__funnelOpenDrawer().catch(function () { window.location.href = '/cart'; });
        return;
      }
      window.location.href = '/cart'; return;
    }
    fetch('/?sections=cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (sections) { drawer.renderContents({ sections: sections }); })
      .catch(function () { drawer.classList.remove('is-empty'); drawer.open(); });
  }

  // ---- CTA2: sample (single or combo) ---------------------------------------
  function sampleIds(btn) {
    var raw = (btn && btn.getAttribute('data-il-sample-ids')) || (C.sampleVariantIds || []).join(',');
    return String(raw).split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  }
  function initSample() {
    var btns = document.querySelectorAll('[data-il-sample]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation(); // funnel-landing's delegated listener must not double-add
        var b = e.currentTarget;
        if (b.getAttribute('data-busy') === '1') return;
        var ids = sampleIds(b); if (!ids.length) return;
        b.setAttribute('data-busy', '1');
        var body = ids.length === 1 ? { id: ids[0], quantity: 1 } : { items: ids.map(function (id) { return { id: id, quantity: 1 }; }) };
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
          .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
          .then(function (cart) {
            lastCartSnapshot = cart;
            var cur = cart.currency || C.currency || 'USD', val = parseFloat(((cart.total_price || 0) / 100).toFixed(2));
            ga4Ads('add_to_cart', cur, val, (cart.items || []).map(function (l) { return { item_id: String(l.product_id || ''), item_name: l.product_title || l.title || '', price: parseFloat(((l.final_price || 0) / 100).toFixed(2)), quantity: l.quantity || 1 }; }), 'sample');
            return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: cartAttributes() }) });
          })
          .then(function () { openDrawerOrCart(); b.setAttribute('data-busy', '0'); })
          .catch(function () { window.location.href = '/cart'; });
      });
    }
  }

  // ---- CTA3: buy (non-blocking, optional discount) --------------------------
  function fillPrice() {
    if (!C.price) return; var txt = '$' + Number(C.price).toFixed(2);
    var els = document.querySelectorAll('[data-il-buy-price]'); for (var i = 0; i < els.length; i++) els[i].textContent = txt;
  }
  function doBuy(email) {
    var start = email ? fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KL_CO, { method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2024-10-15' }, body: JSON.stringify({ data: { type: 'subscription', attributes: { profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { list: { data: { type: 'list', id: C.subscribeListId || 'WQYu7c' } } } } }) }).catch(function () {}) : Promise.resolve();
    return start.then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: C.buyVariantId, quantity: 1 }) }); })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function (li) {
        var price = parseFloat(((li.final_price || li.price || Math.round((C.price || 0) * 100)) / 100).toFixed(2));
        var pid = String(li.product_id || C.productId || ''), name = li.title || C.productName || '';
        if (email) { var lq = window._learnq = window._learnq || []; lq.push(['track', 'Added to Cart', { $value: price, AddedItemProductName: name, AddedItemProductID: pid, AddedItemPrice: price, AddedItemQuantity: 1, CheckoutURL: 'https://' + location.host + '/checkout', Items: [{ ProductID: pid, ProductName: name, Quantity: 1, ItemPrice: price }] }]); }
        var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || C.currency || 'USD';
        ga4Ads('add_to_cart', cur, price, [{ item_id: pid, item_name: name, price: price, quantity: 1 }], 'full');
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: cartAttributes() }) });
      })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        // begin_checkout / AW checkout conversion do NOT fire here anymore -
        // add and checkout are different events. They fire on the drawer's real
        // Check out click below (GA4 begin_checkout comes from funnel-landing.js,
        // the contract's sole emitter; only the AW conversion is ours).
        lastCartSnapshot = cart;
        if (C.applyDiscount) { fetch('/discount/' + encodeURIComponent(C.applyDiscount)).catch(function () {}); }
        openDrawerOrCart();
      }).catch(function () { window.location.href = '/cart'; });
  }
  function initBuy() {
    fillPrice();
    if (!C.buyVariantId) return;
    var btn = document.getElementById('final-atc-btn'); if (!btn) return;
    // A page may render the buy card more than once (mid-page + bottom). getElementById
    // only ever finds the first, so resolve the fields from the CLICKED card instead -
    // otherwise the second card's email is silently dropped.
    function fieldsFor(b) {
      var card = (b.closest && b.closest('.hero-product-buy')) || document;
      return {
        email: card.querySelector('#final-gate-email') || document.getElementById('final-gate-email'),
        phone: card.querySelector('#final-gate-phone') || document.getElementById('final-gate-phone'),
        err: card.querySelector('#final-gate-err') || document.getElementById('final-gate-err')
      };
    }
    var preEls = document.querySelectorAll('#final-gate-email');
    for (var pi = 0; pi < preEls.length; pi++) {
      if (window.__funnelLeadEmail && !preEls[pi].value) preEls[pi].value = window.__funnelLeadEmail;
    }
    // capture phase so no page-component's generic .hero-cta-buy handler double-fires
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('#final-atc-btn'); if (!b) return;
      var f = fieldsFor(b), emailEl = f.email, err = f.err;
      e.stopImmediatePropagation(); e.preventDefault();
      if (b.getAttribute('data-busy') === '1') return; b.setAttribute('data-busy', '1');
      var raw = ((emailEl ? emailEl.value : '') || window.__funnelLeadEmail || '').trim();
      var email = validEmail(raw) ? raw : ''; if (email) window.__funnelLeadEmail = email;
      // Same optional text-message capture as the lead-magnet form. Never blocks the buy.
      try {
        var buyPhone = toE164(f.phone ? f.phone.value : '');
        if (buyPhone) { window.__funnelLeadPhone = buyPhone; subscribePhone(email, buyPhone); }
      } catch (ePb) {}
      if (err) err.style.display = 'none';
      var orig = b.innerHTML; b.innerHTML = 'Adding to cart…';
      // No navigation anymore - restore the button once the drawer is open.
      var p = doBuy(email);
      function done() { b.innerHTML = orig; b.setAttribute('data-busy', '0'); }
      if (p && typeof p.finally === 'function') p.finally(done); else setTimeout(done, 2500);
    }, true);
  }

  function init() { try { firstTouch(); } catch (e) {} initLeadMagnet(); initSample(); initBuy(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
